export const pathwaysData = [
    {
        id: 'p3',
        name: 'Professional Tutor Development Pack',
        tagline: 'A 6-Month Comprehensive Program',
        description: 'This specially designed pathway equips educators with the tools to radically improve their learners\' skills over a six-month period. It is made up of 5 interconnected courses addressing lower skilled learners, literacy, numeracy, and neurodiversity.',
        modules: [
            {
                title: "Developing Learners' Reading Skills",
                details: "3 online sessions supported with resources",
                workshops: [
                    "Address and dramatically improve learners' reading difficulties",
                    "Transition learners from 'learning to read' to 'reading to learn'",
                    "Overcome challenges that reduce reading comprehension and retention",
                    "Implement immediate strategies to increase resource effectiveness"
                ]
            },
            {
                title: "Improving Writing as a Learning Tool",
                details: "2 online sessions supported with resources",
                workshops: [
                    "Develop learners' core writing skills for coursework and expression",
                    "Utilize writing as a primary tool for critical thinking and learning",
                    "Support learners to report events and structure ideas effectively",
                    "Integrate writing into daily practice to enhance overall learning"
                ]
            },
            {
                title: "Teaching Learners How to Learn",
                details: "3 online sessions supported with resources",
                workshops: [
                    "Empower learners to take ownership of their goals and progress",
                    "Build learner confidence and independence through agency",
                    "Integrate powerful learner agency strategies into all teaching",
                    "Prepare learners for future success with self-management skills"
                ]
            },
            {
                title: "Supporting Neurodiverse Learners",
                details: "3 online sessions supported with resources",
                workshops: [
                    "Recognise the strengths of learners with dyslexia, dyscalculia, or ADHD",
                    "Adapt teaching approaches to remove barriers to engagement",
                    "Help learners access content and demonstrate understanding in new ways",
                    "Apply practical strategies to improve participation, retention, and outcomes"
                ]
            },
            {
                title: "Mastering Numeracy Instruction",
                details: "3 online sessions supported with resources",
                workshops: [
                    "Develop educator capability and confidence in teaching numeracy",
                    "Address the needs of learners lacking foundational math skills",
                    "Equip learners with numeracy for course, life, and workplace demands",
                    "Deliver enjoyable and beneficial numeracy content that engages tutors"
                ]
            }
        ]
    },
    {
        id: 'p1',
        name: 'Foundational Numeracy Pathway',
        tagline: 'Master Foundational & Advanced Numeracy',
        description: 'A comprehensive journey through our Numeracy Toolbox, from foundational number skills to advanced measurement and statistical reasoning.',
        modules: [
            {
                title: "Toolbox 1: Developing Number Skills",
                details: "3 online sessions supported with resources",
                workshops: [
                    "How adult difficulties with number skills interfere with course completion",
                    "Simple strategies to start delivering effective numeracy provision",
                    "Developing addition, subtraction, and multiplicative skills",
                    "Developing a toolbox of contextualised numeracy tasks",
                    "Introduction to a range of resources designed to develop learners’ skills"
                ]
            },
            {
                title: "Toolbox 2: Proportional Thinking",
                details: "3 online sessions supported with resources",
                workshops: [
                    "Understanding decimals, fractions, and percentages",
                    "The importance of proportional reasoning for problem-solving",
                    "A model for developing adult learners’ numeracy skills",
                    "Using diagnostic assessment to target and develop key skills",
                    "Strategies for teaching fractions, decimals, and percentages"
                ]
            },
            {
                title: "Toolbox 3: Measurement & Statistics",
                details: "3 online sessions supported with resources",
                workshops: [
                    "Introduction to Adult Unit Standards 26627 & 2662",
                    "Effective strategies for developing measurement skills",
                    "Practical approaches to teaching statistical reasoning",
                    "Aligning learning activities with unit standard criteria",
                    "Resource introduction for measurement and statistics"
                ]
            },
            {
                title: "Supporting Learners with Dyscalculia",
                details: "3 online sessions supported with resources",
                workshops: [
                    "Understand what dyscalculia is and how it is diagnosed",
                    "Recognise how dyscalculia interferes with life, study, and employment",
                    "Learn effective strategies that work with dyscalculic adults",
                    "Design and implement effective, targeted learning plans"
                ]
            },
            {
                title: "Applying Numeracy: Workplace Problem-Solving",
                details: "3 online sessions supported with resources",
                workshops: [
                    "Apply numerical skills to solve authentic workplace problems",
                    "Develop skills for clear communication of numerical data",
                    "Engage in collaborative problem-solving and decision-making",
                    "Give and receive constructive feedback on data-driven tasks"
                ]
            }
        ]
    },
    {
        id: 'p2',
        name: 'Inclusive Educator Pathway',
        tagline: 'Create an Inclusive & Empowering Classroom',
        description: 'Develop essential skills for modern education, focusing on learner empowerment, supporting neurodiversity, and fostering workplace professionalism.',
        modules: [
            {
                title: "Developing Learner Agency",
                details: "3 online sessions supported with resources",
                workshops: [
                    "Developing a positive learner identity",
                    "Fostering personal learning strategies",
                    "Supporting learners to organise their learning",
                    "Helping learners solve problems, innovate, and learn effectively"
                ]
            },
            {
                title: "Dyscalculia: Supporting Learner Success",
                details: "3 online sessions supported with resources",
                workshops: [
                    "What is dyscalculia and how is it diagnosed?",
                    "How dyscalculia interferes with life, study, and employment",
                    "Effective strategies that work with dyscalculic adults",
                    "Using resources in a targeted way to support and develop skills"
                ]
            },
            {
                title: "Workplace Professionalism & Teamwork",
                details: "3 online sessions supported with resources",
                workshops: [
                    "Effective Communication in a Diverse Workplace",
                    "Understanding Collaboration & Teamwork Dynamics",
                    "Developing Problem-Solving & Decision-Making Skills",
                    "Professional Etiquette & Workplace Conduct"
                ]
            },
            {
                title: "Foundational Numeracy for All Learners",
                details: "3 online sessions supported with resources",
                workshops: [
                    "Address common adult difficulties with number skills",
                    "Utilise simple strategies for effective numeracy provision",
                    "Build learner confidence with addition, subtraction, and multiplication",
                    "Create a toolbox of contextualised, real-world numeracy tasks"
                ]
            },
            {
                title: "Making Sense of Fractions, Decimals & Percentages",
                details: "3 online sessions supported with resources",
                workshops: [
                    "Demystifying decimals, fractions, and percentages for adult learners",
                    "Highlighting the importance of proportional reasoning in everyday life",
                    "Using diagnostic assessment to identify and target key skill gaps",
                    "Applying effective strategies for teaching proportional thinking"
                ]
            }
        ]
    }
];